const bannerImages = {
  banner1: require('./banner_1.jpg'),
  banner2: require('./banner_2.jpg'),
  banner3: require('./banner_3.jpg'),
  banner4: require('./banner_4.jpg'),
  banner5: require('./banner_5.jpg'),
  banner6: require('./banner_6.jpg'),
}

export default bannerImages
